const CALENDAR_CLIP_THUMBNAIL_WIDTH = 160;

const objectUrlCache = new Map();
const inflightRequests = new Map();

export function getCalendarClipThumbnailWidth() {
  return CALENDAR_CLIP_THUMBNAIL_WIDTH;
}

export function buildClipThumbnailUrl(fileStem, clipFilename, maxWidth = CALENDAR_CLIP_THUMBNAIL_WIDTH) {
  if (!fileStem || !clipFilename) return null;
  const params = new URLSearchParams({
    file_stem: fileStem,
    clip_filename: clipFilename,
    max_width: String(maxWidth),
  });
  return `/api/user/clip/thumbnail?${params}`;
}

export async function fetchClipThumbnailObjectUrl(url, getFreshToken) {
  if (!url) return null;

  const cached = objectUrlCache.get(url);
  if (cached) return cached;

  const pending = inflightRequests.get(url);
  if (pending) return pending;

  const request = (async () => {
    try {
      const token = typeof getFreshToken === 'function' ? await getFreshToken() : null;
      if (!token) return null;

      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) return null;

      const blob = await res.blob();
      const objectUrl = URL.createObjectURL(blob);
      objectUrlCache.set(url, objectUrl);
      return objectUrl;
    } catch {
      return null;
    } finally {
      inflightRequests.delete(url);
    }
  })();

  inflightRequests.set(url, request);
  return request;
}
